import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import ThemeProvider from "./contexts/ThemeProvider.tsx";
import { ThemeProvider as ControlThemeProvider } from "./contexts/ThemeContext.tsx";
import AppRoutes from "./routes/AppRoutes.tsx";
import MainLayout from "./pages/MainLayout/index.tsx";
import { AuthProvider } from "./contexts/AuthContext.tsx";
import { FeedbackProvider } from "./contexts/FeedbackContext.tsx";
import { NotificationProvider } from "./contexts/NotificationContext.tsx";
import { PagamentoProvider } from "./contexts/PagamentoContext.tsx";
import "@fontsource/josefin-sans/100.css";
import "@fontsource/josefin-sans/200.css";
import "@fontsource/josefin-sans/300.css";
import "@fontsource/josefin-sans/400.css";
import "@fontsource/josefin-sans/500.css";
import "@fontsource/josefin-sans/600.css";
import "@fontsource/josefin-sans/700.css";
import { PlanoProvider } from "./contexts/PlanoContext.tsx";
import { PermissoesProvider } from "./contexts/PermissoesContext.tsx";
import "bootstrap-icons/font/bootstrap-icons.css";

const App = () => {
  return (
    <FeedbackProvider>
      <PlanoProvider>
        <PagamentoProvider>
          <AuthProvider>
            {/* PermissoesProvider mudou para DENTRO do Router (abaixo): ele
                precisa enxergar a navegacao para recarregar quando o token muda.
                Ficando aqui fora, carregava uma unica vez no boot - antes de
                qualquer login - e a sessao inteira rodava com os dados do
                usuario anterior ate alguem dar F5. */}
              <ControlThemeProvider>
                <ThemeProvider>
                  <CssBaseline />
                  <Router>
                    {/* NotificationProvider desceu para DENTRO do Router pelo mesmo
                        motivo do PermissoesProvider: fora daqui ele carregava uma
                        unica vez no boot — na tela de login, sem token — e como o
                        login usa navigate() (sem recarregar a pagina) nunca mais
                        refazia a busca. O sino ficava vazio ate alguem dar F5. */}
                    <NotificationProvider>
                      <PermissoesProvider>
                        <MainLayout>
                          <AppRoutes />
                        </MainLayout>
                      </PermissoesProvider>
                    </NotificationProvider>
                  </Router>
                </ThemeProvider>
              </ControlThemeProvider>
          </AuthProvider>
        </PagamentoProvider>
      </PlanoProvider>
    </FeedbackProvider>
  );
};

export default App;
